module.exports = __webpack_public_path__ + "static/img/sam.be458b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/sam.jpg
// module id = YBpF
// module chunks = 0